/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { invoiceChecksLogCells } from './gridComponents/tableHead';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import moment from 'moment';
import { handleCommaSeparatedAmount } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export default function InvoiceChecksLog(props) {
  const { checkLogDetails } = props;
  const handleAssociateWithCheck = (row) => {
    props.sendData(row);
  };
  return (
    <>
      <div className="">
        <Grid
          rowData={
            checkLogDetails?.data?.map((item) => {
              item.checkPayeeCdVal = item.checkPayeeCd;
              item.batchDt = item.batchDt
                ? moment(item?.batchDt).format('MM/DD/YYYY')
                : null;
              item.checkDt = item.checkDt
                ? moment(item?.checkDt).format('MM/DD/YYYY')
                : null;
              item.postmarkedDt = item.postmarkedDt
                ? moment(item?.postmarkedDt).format('MM/DD/YYYY')
                : null;
              item.receivedDt = item.receivedDt
                ? moment(item?.receivedDt).format('MM/DD/YYYY')
                : null;
              if (!item.totAllocatedAmt?.toString()?.includes('$'))
                item.totAllocatedAmt = item.totAllocatedAmt
                  ? handleCommaSeparatedAmount(item.totAllocatedAmt)
                  : `$ ${parseFloat(0).toFixed(2)}`;
              if (!item.checkAmt?.toString()?.includes('$'))
                item.checkAmt = item.checkAmt
                  ? handleCommaSeparatedAmount(item.checkAmt)
                  : `$ ${parseFloat(0).toFixed(2)}`;
              return item;
            }) || []
          }
          columnDefs={invoiceChecksLogCells}
          isScrollOn
          exportFile
          animateRows
          fileName="Check Grid"
          sideBar={false}
          navigateToNextCell={navigateToNextCell}
          tabToNextCell={tabToNextCell}
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          onSelect={(e) => {
            handleAssociateWithCheck(e?.data);
          }}
          frameworkComponents={{
            NameRenderCheckIssuer: (cellInfo) => {
              const name = cellInfo?.data?.checkIssuer;
              if (name && name.length > 22) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                  >
                    <div>{name}</div>
                  </OverlayTrigger>
                );
              }
              return <div>{name}</div>;
            },
            NameRenderCheckIdentifier: (cellInfo) => {
              const name = cellInfo?.data?.checkIdentifier;
              if (name && name.length > 15) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                  >
                    <div>{name}</div>
                  </OverlayTrigger>
                );
              }
              return <div>{name}</div>;
            },
            NameRenderBatchNum: (cellInfo) => {
              const name = cellInfo?.data?.batchNum;
              if (name && name.length > 15) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                  >
                    <div>{name}</div>
                  </OverlayTrigger>
                );
              }
              return <div>{name}</div>;
            },
            NameRenderInformation: (cellInfo) => {
              const name = cellInfo?.data?.checkInfo;
              if (name && name.length > 15) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                  >
                    <div>{name}</div>
                  </OverlayTrigger>
                );
              }
              return <div>{name}</div>;
            },
            CheckAmtCellRender: (cellInfo) => {
              const isNegativeVal = !(
                parseFloat(
                  cellInfo?.data?.checkAmt?.toString().split('$')[1]
                ) >= 0
              );
              return (
                <>
                  {isNegativeVal ? (
                    <div
                      style={{ color: '#eb0000' }}
                    >{`(${cellInfo?.data?.checkAmt
                      ?.toString()
                      ?.replace('-', '')
                      .trim()})`}</div>
                  ) : (
                    <div>{`${cellInfo?.data?.checkAmt}`}</div>
                  )}
                </>
              );
            },
            TotAllocatedAmtCellRender: (cellInfo) => {
              const isNegativeVal = !(
                parseFloat(
                  cellInfo?.data?.totAllocatedAmt?.toString().split('$')[1]
                ) >= 0
              );
              return (
                <>
                  {isNegativeVal ? (
                    <div
                      style={{ color: '#eb0000' }}
                    >{`(${cellInfo?.data?.totAllocatedAmt
                      ?.toString()
                      ?.replace('-', '')
                      .trim()})`}</div>
                  ) : (
                    <div>{`${cellInfo?.data?.totAllocatedAmt}`}</div>
                  )}
                </>
              );
            },
          }}
        />
      </div>
    </>
  );
}
